import React, { FC, useState, useEffect } from 'react';
import qs from 'qs';
import { isEmpty } from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import { AuthWrapper } from '@src/components/AuthWrapper';
import { PasswordInput } from '@src/components/PasswordInput';
import { Button } from '@src/components/Button';
import { useResetPasswordMutation } from '@src/graphql/generated';
import { Error } from '@src/components/PasswordInput/interfaces/error.interface';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { useAppDispatch } from '@src/redux';
import { LOGIN_ROUTE } from '@src/Routes/links';
import { trackEvent } from '@src/metrics';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { getPasswordErrorMessage } from '@src/util/validation';
import './styles.scss';

export const ResetPassword: FC = () => {
  const history = useHistory();

  const location = useLocation();

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  const [newPassword, setNewPassword] = useState<string>('');

  const [errors, setErrors] = useState<Error>();

  const dispatch = useAppDispatch();

  const [resetPassword, { loading: isLoading }] = useResetPasswordMutation({
    onCompleted: () => {
      history.replace(LOGIN_ROUTE);
    },
    onError: () => {
      dispatch(setErrorFlashMessage());
    },
  });

  useEffect(() => {
    trackEvent({
      context: MetricContext.RESET_PASSWORD_PAGE,
      interaction: MetricAction.VIEW_RESET_PASSWORD_PAGE,
    });
  }, []);

  const isLoginButtonDisabled = isLoading;

  const onPasswordResetRequest = () => {
    const message = getPasswordErrorMessage(newPassword);

    if (!isEmpty(message)) {
      setErrors(message);

      return;
    }

    if (queryParams && typeof queryParams.token === 'string') {
      resetPassword({
        variables: {
          resetInput: {
            password: newPassword.trim(),
            passwordResetToken: queryParams.token,
          },
        },
      });

      trackEvent({
        context: MetricContext.RESET_PASSWORD_PAGE,
        interaction: MetricAction.REQUEST_PASSWORD_RESET,
      });
    }
  };

  return (
    <AuthWrapper wrapperClassName="reset-password">
      <div className="reset-password__header-content">
        <h3>Set your new password</h3>
      </div>

      <div>
        <PasswordInput
          errors={errors}
          onChange={value => {
            setErrors(undefined);
            setNewPassword(value);
          }}
          value={newPassword}
        />
      </div>

      <div className="reset-password__actions">
        <Button isDisabled={isLoginButtonDisabled} onClick={onPasswordResetRequest}>
          Set password
        </Button>
      </div>
    </AuthWrapper>
  );
};
